// src/redux/termApi.js
import { apiSlice } from "./apiSlice";

export const termApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        getTermById: build.query({
            query: ({ termId }) => ({
                url: `/api/user/term/v1/${termId}`,
                method: "get",
                headers: { token: true },
            }),
        }),
        putTerm: build.mutation({
            query: ({ termId, body }) => ({
                url: `/api/user/term/v1/${termId}`,
                method: "put",
                data: body,
                headers: { token: true },
            }),
        }),
        deleteTerm: build.mutation({
            query: (termId) => ({
                url: `/api/user/term/v1/${termId}`,
                method: "delete",
                headers: { token: true },
            }),
        }),
        getTermList: build.query({
            query: (params) => ({
                url: `/api/user/term/v1`,
                method: "get",
                headers: { token: true },
                params,
            }),
        }),
        postTerm: build.mutation({
            query: (body) => ({
                url: `/api/user/term/v1`,
                method: "post",
                data: body,
                headers: { token: true },
            }),
        }),
    }),
});

export const { useGetTermByIdQuery, usePutTermMutation, useDeleteTermMutation, useGetTermListQuery, usePostTermMutation } = termApi;
